import script from "./NewSimulation.vue?vue&type=script&setup=true&lang=js"
export * from "./NewSimulation.vue?vue&type=script&setup=true&lang=js"

import "./NewSimulation.vue?vue&type=style&index=0&id=a40505ca&lang=scss&scoped=true"

import exportComponent from "/home/deployer/deploypad/silogues/releases/20261022152544/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a40505ca"]])

export default __exports__